module.exports = __webpack_public_path__ + "img/space_key.5fcf9fc4.svg";